export default {
  site_name: "91影视看片下载",
  site_subtitle: "手机影视APP免费看片软件安装",
  nav_home: "首页",
  nav_category: "分类浏览",
  nav_about: "关于我们",
  nav_download: "立即下载",
  hero_title: "随时随地 高清追剧",
  hero_subtitle: "91影视看片APP，海量影视资源免费看，安卓手机即装即看",
  hero_cta: "免费下载APP",
  hero_secondary: "了解更多",
  features_title: "为什么选择91影视看片",
  features_subtitle: "千万用户的选择，值得信赖的手机影视APP",
  feature_1_title: "海量资源",
  feature_1_desc: "覆盖电影、电视剧、综艺、动漫、纪录片等全品类影视内容，每日更新不断片",
  feature_2_title: "高清画质",
  feature_2_desc: "支持1080P超清画质播放，智能适配网络环境，流畅不卡顿",
  feature_3_title: "完全免费",
  feature_3_desc: "无需会员、无需付费，所有影视资源免费观看，真正的免费看片软件",
  feature_4_title: "离线下载",
  feature_4_desc: "支持一键离线缓存，无网络也能随时随地观看，地铁飞机都能看",
  feature_5_title: "极速播放",
  feature_5_desc: "采用P2P加速技术，播放速度更快更稳定，告别缓冲等待",
  feature_6_title: "纯净体验",
  feature_6_desc: "无广告干扰，界面简洁清爽，专注观影体验",
  category_title: "分类浏览",
  category_subtitle: "发现你感兴趣的影视内容",
  category_hot: "热门推荐",
  category_movie: "最新电影",
  category_tv: "电视剧",
  category_variety: "综艺节目",
  category_anime: "动漫动画",
  category_doc: "纪录片",
  recommend_title: "热门推荐",
  recommend_subtitle: "大家都在看的精彩内容",
  download_title: "立即下载91影视看片APP",
  download_subtitle: "扫描二维码或点击下载，开启高清追剧之旅",
  download_btn: "安卓APP免费下载",
  download_tip: "支持Android 5.0及以上版本",
  footer_desc: "91影视看片下载官网，提供最新91影视看片APP下载，安卓手机影视APP免费安装，看片软件随时随地高清追剧。",
  footer_links: "快速链接",
  footer_contact: "联系我们",
  footer_copyright: "© 2026 91影视看片下载官网 版权所有",
  about_title: "关于我们",
  about_brand: "品牌介绍",
  about_story: "品牌故事",
  about_reputation: "用户口碑",
  about_contact: "联系我们",
  contact_name: "姓名",
  contact_email: "邮箱",
  contact_message: "留言",
  contact_submit: "提交留言",
  contact_success: "留言提交成功，我们会尽快回复！",
  breadcrumb_home: "首页",
  read_more: "阅读全文",
  back_to_list: "返回列表",
  prev_article: "上一篇",
  next_article: "下一篇",
  scroll_top: "回到顶部",
  no_content: "暂无内容",
  page_not_found: "页面未找到",
  view_detail: "查看详情",
};